import React from 'react';

const brandColors = {
  primary: '#29779e',
  secondary: '#479b9d',
  accent: '#66c19d',
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
          <div className="max-w-md w-full text-center">
            <div
              className="w-20 h-20 mx-auto mb-6 rounded-2xl flex items-center justify-center"
              style={{ background: `${brandColors.primary}10` }}
            >
              <svg
                className="w-10 h-10"
                style={{ color: brandColors.primary }}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z"
                />
              </svg>
            </div>
            <h1 className="font-montserrat font-black text-2xl text-gray-900 mb-3">
              Something went wrong
            </h1>
            <p className="font-poppins text-gray-600 mb-8">
              An unexpected error occurred. Please try refreshing the page.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <button
                onClick={() => window.location.reload()}
                className="w-full sm:w-auto rounded-full px-6 py-3 font-poppins font-semibold text-white transition-all duration-300 hover:shadow-lg hover:scale-105"
                style={{
                  background: `linear-gradient(135deg, ${brandColors.primary}, ${brandColors.secondary})`,
                }}
              >
                Refresh Page
              </button>
              <button
                onClick={this.handleReset}
                className="w-full sm:w-auto rounded-full px-6 py-3 font-poppins font-semibold text-gray-700 bg-white border-2 border-gray-200 transition-all duration-300 hover:border-gray-300"
              >
                Go Home
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
